import React, { FC, useEffect, useState } from "react";
import { Form, Button, Spin } from "antd";
import PreAuthAdmissionData from "./OP/PreAuthAdmissionData";
import DocumentUpload from "./DocumentUpload";
import ResponseDocumentUpload from "./ResponseDocumentUpload";
import PreAuthEchsData from "./IP/PreAuthEchsData";
import EchsEmergencyAdmissionForm from "./Emergency/EchsEmergencyAdmissionForm";
import EchsEmergencyMedicalHistoryForm from "./Emergency/EchsEmergencyMedicalHistoryForm";
import EchsEmergencyClinicalFindingsForm from "./Emergency/EchsEmergencyClinicalFindingsForm";
import EchsEmergencyDiagnosticForm from "./Emergency/EchsEmergencyDiagnosticForm";
import EchsEmergencyTreatmentForm from "./Emergency/EchsEmergencyTreatmentForm";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import PatientDetails from "./PatientDetails";
import { Collapse } from "antd";
import WithoutReferral from "./WithoutReferral";

interface PreAuthEchsProps {
  form: any;
  visitType: any;
  loading: boolean;
  documentTypes: any[];
  documentUrls: any[];
  documentRequestResponseDocuments: any;
  handleFileChange: any;
  handleOpen: any;
  handleSaveData: () => Promise<void>;
  isSubmitting: boolean;
  preAuth: any;
  hasFunctionality: (key: string) => boolean;
  handleSaveConfirmationModal: (state: string) => void;
  isApproved: boolean;
  isApprovedInitiated: boolean;
  activeKey: any;
  referralPresent: any;
  ageBelowSeventyWithoutReferral: any;
  ageAboveSeventyWithoutReferral: any;
  renderActionButtons: () => React.ReactNode;
  portalSubmission: any;
  uploadFileList: any;
  isIntimated: any;
  removedDiagnoses: any;
  setRemovedDiagnoses: any;
  polyclinicList?: any[];
}

const { Panel } = Collapse;

const PreAuthEchs: FC<PreAuthEchsProps> = ({
  form,
  visitType,
  loading,
  documentTypes,
  documentUrls,
  documentRequestResponseDocuments,
  handleFileChange,
  handleOpen,
  handleSaveData,
  isSubmitting,
  preAuth,
  hasFunctionality,
  handleSaveConfirmationModal,
  isApproved,
  isApprovedInitiated,
  activeKey,
  referralPresent,
  ageAboveSeventyWithoutReferral,
  ageBelowSeventyWithoutReferral,
  renderActionButtons,
  portalSubmission,
  uploadFileList,
  isIntimated,
  removedDiagnoses,
  setRemovedDiagnoses,
  polyclinicList,
}) => {
  const { patients, auth } = useSelector((state: RootState) => state);

  const styles = React.useMemo(
    () => ({
      mainContent: {
        background: "#FFFFFF",
        borderRadius: "10px",
        padding: "20px",
        marginBottom: "20px",
      },
      saveBtn: {
        color: "white",
        background: "#008B8B",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 16px",
      },
      editBtn: {
        color: "#008B8B",
        background: "white",
        border: "1px solid #008B8B",
        boxShadow: "0px 2px 8px 0px #00000040",
        borderRadius: "10px",
        padding: "12px 16px",
      },
    }),
    [],
  );

  return (
    <div>
      <Form
        form={form}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%" }}
      >
        {visitType === "OP" && referralPresent ? (
          <PreAuthAdmissionData
            form={form}
            disabled={portalSubmission}
            ageBelowSeventyWithoutReferral={ageBelowSeventyWithoutReferral}
            ageAboveSeventyWithoutReferral={ageAboveSeventyWithoutReferral}
          />
        ) : visitType === "OP" && !referralPresent ? (
          <WithoutReferral form={form} disabled={portalSubmission} polyclinicList={polyclinicList} />
        ) : visitType === "EMERGENCY" || !referralPresent ? (
          <div>
            <div>
              <h3>PATIENT DETAILS</h3>
              <PatientDetails
                form={form}
                // loading={loading}
                disabled={portalSubmission}
              />
            </div>
            <div>
              <h3>Admission Data</h3>
              <EchsEmergencyAdmissionForm
                form={form}
                loading={loading}
                disabled={portalSubmission}
                polyclinicList={polyclinicList}
              />
            </div>

            {/* <div className="emergency-section">
              <Collapse
                // defaultActiveKey={["1"]}
                expandIconPosition="start"
                // defaultActiveKey={["1"]}
                // expandIconPosition="start"
                style={{
                  border: "1px solid lightgray",
                  borderRadius: "20px",
                  marginBottom: "0.8rem",
                  background: "#F2F6F9",
                  padding: "2px 14px",
                }}
              >
                <Panel
                  header={
                    <div
                      style={{
                        textDecoration: "underline",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      Medical History
                    </div>
                  }
                  key="1"
                >
                  <EchsEmergencyMedicalHistoryForm
                    form={form}
                    loading={loading}
                    disabled={portalSubmission}
                  />
                </Panel>
              </Collapse>
            </div> */}

            <div className="emergency-section">
              <Collapse
                // defaultActiveKey={["1"]}
                expandIconPosition="start"
                style={{
                  border: "1px solid lightgray",
                  borderRadius: "20px",
                  marginBottom: "0.8rem",
                  background: "#F2F6F9",
                  padding: "2px 14px",
                }}
              >
                <Panel
                  header={
                    <div
                      style={{
                        textDecoration: "underline",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      Clinical Findings
                    </div>
                  }
                  key="1"
                >
                  <EchsEmergencyClinicalFindingsForm
                    form={form}
                    loading={loading}
                    disabled={portalSubmission}
                  />
                </Panel>
              </Collapse>
            </div>

            <div className="emergency-section">
              <h3>Diagnostic Data</h3>
              <EchsEmergencyDiagnosticForm
                form={form}
                loading={loading}
                disabled={portalSubmission}
                removedDiagnoses={removedDiagnoses}
                setRemovedDiagnoses={setRemovedDiagnoses}
              />
            </div>

            <div className="emergency-section">
              <Collapse
                // defaultActiveKey={["1"]}
                expandIconPosition="start"
                style={{
                  border: "1px solid lightgray",
                  borderRadius: "20px",
                  marginBottom: "0.8rem",
                  background: "#F2F6F9",
                  padding: "2px 14px",
                }}
              >
                <Panel
                  header={
                    <div
                      style={{
                        textDecoration: "underline",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      Proposed Treatment
                    </div>
                  }
                  key="1"
                >
                  <EchsEmergencyTreatmentForm
                    form={form}
                    loading={loading}
                    disabled={portalSubmission}
                  />
                </Panel>
              </Collapse>
            </div>
          </div>
        ) : (
          referralPresent && (
            <div>
              <PreAuthEchsData
                form={form}
                disabled={portalSubmission}
                ageBelowSeventyWithoutReferral={ageBelowSeventyWithoutReferral}
                ageAboveSeventyWithoutReferral={ageAboveSeventyWithoutReferral}
              />
              {/* <div className="emergency-section">
                <Collapse
                // defaultActiveKey={["1"]}
                expandIconPosition="start"
                style={{
                  border: "1px solid lightgray",
                  borderRadius: "20px",
                  marginBottom: "0.8rem",
                  background: "#F2F6F9",
                  padding: "2px 14px",
                }}
              >
                <Panel
                  header={
                    <div
                      style={{
                        textDecoration: "underline",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      Medical History
                    </div>
                  }
                  key="1"
                >
                <EchsEmergencyMedicalHistoryForm
                  form={form}
                  loading={loading}
                  disabled={portalSubmission}
                />
                </Panel>
              </Collapse>
              </div>

              <div className="emergency-section">
                <Collapse
                // defaultActiveKey={["1"]}
                expandIconPosition="start"
                style={{
                  border: "1px solid lightgray",
                  borderRadius: "20px",
                  marginBottom: "0.8rem",
                  background: "#F2F6F9",
                  padding: "2px 14px",
                }}
              >
                <Panel
                  header={
                    <div
                      style={{
                        textDecoration: "underline",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      Clinical Findings
                    </div>
                  }
                  key="1"
                >
                <EchsEmergencyClinicalFindingsForm
                  form={form}
                  loading={loading}
                  disabled={portalSubmission}
                />
                </Panel>
              </Collapse>
              </div> */}

              <div className="emergency-section">
                <h3>Diagnostic Data</h3>
                <EchsEmergencyDiagnosticForm
                  form={form}
                  loading={loading}
                  disabled={portalSubmission}
                  removedDiagnoses={removedDiagnoses}
                  setRemovedDiagnoses={setRemovedDiagnoses}
                />
              </div>

              <div className="emergency-section">
                <Collapse
                  // defaultActiveKey={["1"]}
                  expandIconPosition="start"
                  style={{
                    border: "1px solid lightgray",
                    borderRadius: "20px",
                    marginBottom: "0.8rem",
                    background: "#F2F6F9",
                    padding: "2px 14px",
                  }}
                >
                  <Panel
                    header={
                      <div
                        style={{
                          textDecoration: "underline",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        Proposed Treatment
                      </div>
                    }
                    key="1"
                  >
                    <EchsEmergencyTreatmentForm
                      form={form}
                      loading={loading}
                      disabled={portalSubmission}
                    />
                  </Panel>
                </Collapse>
              </div>
            </div>
          )
        )}

        {loading ? (
          <div
            style={{
              margin: "auto",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          documentRequestResponseDocuments?.["requestedDocuments"].length >
            0 && (
            <DocumentUpload
              documentTypes={documentTypes}
              documentUrls={documentUrls}
              handleFileChange={handleFileChange}
              handleOpen={handleOpen}
              portalSubmission={!!portalSubmission}
              documentRequestResponseDocuments={
                documentRequestResponseDocuments
              }
              isApproved={isApproved}
              uploadFileList={uploadFileList}
              isIntimated={isIntimated}
              isEchsOPPreAuth={
                patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                "OP"
              }
            />
          )
        )}

        {documentRequestResponseDocuments?.["responseDocuments"].length > 0 && (
          <ResponseDocumentUpload
            documentTypes={documentTypes}
            documentUrls={documentUrls}
            handleFileChange={handleFileChange}
            handleOpen={handleOpen}
            portalSubmission={!!portalSubmission}
            documentRequestResponseDocuments={documentRequestResponseDocuments}
            handleSaveData={handleSaveData}
            currentStage={preAuth?.stepperData?.currentVisitStage}
            activeKey={activeKey}
            uploadFileList={uploadFileList}
          />
        )}

        {/* Replace the old button section with the new renderActionButtons */}
        {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
          "OP" &&
        (preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsReferralResponse
          ?.claimId ||
          preAuth?.portalData?.casePreAuthEchs?.casePreAuthEchsEmergencyResponse
            ?.claimId) ? (
          <></>
        ) : (
          renderActionButtons()
        )}
      </Form>
    </div>
  );
};

export default React.memo(PreAuthEchs);
